import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { App } from './appPuWeb';

const history = createBrowserHistory();

const rootElement = document.getElementById('root');

render(
  <Router history={history}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Router>,
  rootElement,
);
